module.exports = __webpack_public_path__ + "static/media/monet-3.bf156e3f.jpeg";